import type { localeNames } from "@dealer-center/core-interfaces-locale";
import { isLocaleName } from "@dealer-center/core-interfaces-locale";

export function getLocaleFromURL(optionalUrl_?: string | undefined) {
  const optionalUrl = optionalUrl_ || window.location.search;
  const foundIdx = optionalUrl.indexOf("lang=");
  let locale: string | null = null;
  if (foundIdx > -1 && optionalUrl.length - foundIdx >= 10) {
    locale = optionalUrl.substr(foundIdx + 5, 5);
    locale = locale.replace("_", "-");
    if (!/([a-z][a-z]-[A-Z][A-Z])/.test(locale)) {
      // Validate it
      locale = null;
    }
  }

  return locale;
}

const defaultLocale: localeNames = "en-US";

export function getLocale(currentLocale?: string) {
  // Note that navigator.languages[0] is used by Accept-Language (https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/languages)
  // Our api uses standard hyphen; cc uses underscores
  const urlLocale = getLocaleFromURL();

  const curLocale =
    urlLocale ||
    currentLocale?.replace("_", "-") ||
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.language;

  // only return supported locales
  return isLocaleName(curLocale) ? curLocale : defaultLocale;
}
